<template>
	<div class="logText" v-html="line[item.value]"></div>
</template>

<script>
export default {
	name: "ModLog",
	props: {
		item: Object,
		line: Object
	},
};
</script>

<style scoped lang="scss">
.logText {
	::v-deep .logTextChanged {
		color: var(--base-orange-dark);
	}

	::v-deep .logTextAdded {
		color: var(--base-blue-dark);
	}

	::v-deep .logTextRemove {
		color: var(--base-red-dark);
	}

	::v-deep .logTextValue {
		color: var(--base-green-dark);
	}
}
</style>

